<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <loading :active.sync="loading"
             :can-cancel="false"
             :is-full-page="true"></loading>

    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars"/>
    </button>

    <div class="navbar-logo"></div>
    <div class="navigation-box"></div>

    <div class="user-settings">
      <button @click="syncData" class="burger">
        <font-awesome-icon icon="fa-solid fa-arrows-rotate"/>
      </button>
    </div>
  </div>
</template>

<script>


import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "NavigationBar",
  computed : {
    loading () {
      return this.$store.getters.getLoadingState;
    }
  },
  props: {
    toggle: {
      type: Function,
      require: true
    },
  },
  methods: {
    async syncData() {
      if (this.$route.path === "/pending-orders") {
        this.$utils.showLoading();
        return window.location.reload(true);
      }

      await this.$store.dispatch('getSupervisors');
      const allUsers = await this.$store.getters.getSupervisors;
      const supervisors = Array.isArray(allUsers) ? allUsers.filter(user => user.process_type === 'checkout') : [];

      if (supervisors.length === 0) {
        return Swal.fire("No Supervisors Found", "Please contact an administrator.", "warning");
      }

      const { value: selectedSupervisorName } = await Swal.fire({
        title: "Select Supervisor",
        input: "select",
        inputOptions: supervisors.reduce((acc, sup) => {
          acc[sup.name] = sup.name || sup.Name || `Supervisor ${sup.id}`;
          return acc;
        }, {}),
        inputPlaceholder: "Select a supervisor",
        showCancelButton: false,
        showCloseButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        inputValidator: (value) => {
          return value ? undefined : "Please select a supervisor";
        }
      });

      if (!selectedSupervisorName) return;
      const orderNumber = this.$route.query.orderNumber;

      this.$utils.showLoading();
      try {
        await axios.post(`${navTomcatApi}otp/checkout/individual`, {}, {
          params: {
            name: selectedSupervisorName,
            PickingID : orderNumber
          }
        });
      } catch (error) {
        return Swal.fire("Error", "Failed to generate OTP. Please try again.", "error");
      } finally {
        this.$utils.hideLoading();
      }

      const { value: password } = await Swal.fire({
        title: "Supervisor Authentication",
        input: "number",
        inputLabel: "Enter OTP sent to Supervisor",
        inputPlaceholder: "Enter OTP",
        inputAttributes: {
          autocapitalize: "off",
          autocomplete: "off"
        },
        showCancelButton: false,
        showCloseButton: false,
        confirmButtonText: "Submit",
        icon: "warning",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showLoaderOnConfirm: true,
        preConfirm: (input) => {
          if (!input) {
            Swal.showValidationMessage("OTP cannot be empty!");
          }
          return input;
        }
      });

      if (password) {
        this.$store.dispatch(`validateManager`, password).then((res) => {
          if (res) {
            window.location.reload(true);
          } else {
            Swal.fire("Error", "Incorrect OTP!", "error");
          }
        });
      }
    }
  }
}
</script>

<style scoped>
.burger {
  width: 40px;
  height: 40px;
  background: transparent;
  color: white;
  font-size: 30px;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
</style>
